import type { NextPage } from 'next'
import styles from './PostSC.module.scss'
import ComponentHeader from 'componentsUnits/componentHeader'
import PostComponent from './postComponent'
import { useRouter } from 'next/navigation'
import { Size } from 'types/size'
import Subtitle from 'componentsUnits/subtitle'
import { EntryDateIndex } from 'reducers/postReducer'
import { Type } from 'types/type'
import Break from 'componentsUnits/break'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { useAppSelector } from 'reducers/storeHooks'

interface Props {
  title: string
  entryDateIndex: EntryDateIndex[]
  showMoreEnabled?: boolean
  noEntriesText?: string
  isLoading?: boolean
  hideImages?: boolean
  hideVideos?: boolean
}
const PostScrollComponent: NextPage<Props> = (props: Props) => {
  const router = useRouter()
  const posts = useAppSelector((state) => state.postReducer.posts)
  if (!props.entryDateIndex) return null

  return (
    <div className={styles.container}>
      {props.title && props.entryDateIndex.length > 0 && (
        <ComponentHeader
          title={props.title}
          buttonText={props.showMoreEnabled ? 'Show More +' : undefined}
          buttonOnClick={
            props.showMoreEnabled
              ? () => {
                router.push('/posts')
              }
              : undefined
          }
        />
      )}
      <div className={styles.component_list_wrapper}>
        {props.entryDateIndex.length > 0 &&
          props.entryDateIndex.map((c: EntryDateIndex, i: number) => {
            if (props.hideImages && posts.get(c.entryId)?.image) return null
            if (props.hideVideos && posts.get(c.entryId)?.video) return null
            return (
              <div key={i} className={styles.post_container}>
                <PostComponent key={c.entryId} entryDateIndex={c} />
                {i < (props.entryDateIndex?.length ?? 0) - 1 &&
                  <Break />
                }
              </div>
            )
          }
          )
        }

        {props.entryDateIndex?.length === 0 && props.noEntriesText && (
          <Subtitle text={props.noEntriesText} type={Type.t1} size={Size.xSmall} />
        )}

        {props.isLoading && (
          <Skeleton height={250} />
        )}
      </div>
    </div>
  )
}

export default PostScrollComponent
